<template>
  <svg :x="x" :y="y" :width="`${widthInInches}in`" :height="`${heightInInches}in`" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <pattern v-if="surfaceTexture" :x="surfaceTexturePatternOrigin.x" :y="surfaceTexturePatternOrigin.y" :id="`${uuid}-mount-tile-pattern`" patternUnits="userSpaceOnUse" :width="surfaceTexture.widthInInches" :height="surfaceTexture.heightInInches">
        <image :href="surfaceTexture.url" :width="surfaceTexture.widthInInches" :height="surfaceTexture.heightInInches" preserveAspectRatio="xMaxYMin" />
      </pattern>
    </defs>

    <rect
      :width="widthInInches"
      :height="heightInInches"
      :fill="mountColor"
    />
  </svg>
</template>

<script>
import { primaryMatColors } from "../../hardCodedValues";
import uuidv4 from "uuid/v4";

export default {
  props: {
    frameSpec: {
      type: Object,
      required: true
    },
    widthInInches: {
      type: Number,
      required: true
    },
    heightInInches: {
      type: Number,
      required: true
    },
    x: {
      type: Number,
      default: 0
    },
    y: {
      type: Number,
      default: 0
    }
  },
  computed: {
    uuid() {
      return uuidv4();
    },
    mountColor() {
      const mountName = this.frameSpec.mount.name;
      const hardCodedMat = primaryMatColors.find(color => color.name === mountName);
      
      if (!hardCodedMat) {
        return 'white';
      } else if (hardCodedMat.surfaceTexture) {
        return `url(#${this.uuid}-mount-tile-pattern)`;
      } else {
        return hardCodedMat.surfaceColor || 'transparent';
      }
    },
    surfaceTexture () {
      const mountName = this.frameSpec.mount.name;
      const hardCodedMat = primaryMatColors.find(color => color.name === mountName);
      return hardCodedMat ? hardCodedMat.surfaceTexture : {};
    },
    surfaceTexturePatternOrigin () {
      if (this.surfaceTexture && this.surfaceTexture.alignment === "center") {
        return {
          x: (this.widthInInches - this.surfaceTexture.widthInInches) / 2,
          y: (this.heightInInches - this.surfaceTexture.heightInInches) / 2
        };
      } else {
        return {
          x: '0',
          y: '0'
        };
      }
    }
  },
};
</script>

<style scoped>
/* No styles needed */
</style>
